import BuyoutRecord from "integration/revolver/schema/buyout-record";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import Record from "slotworks/model/gameplay/records/record";

export default function getJackpotTypeFromSymbol(record: Record) {
    let result = "";
    if(record instanceof BuyoutRecord) {
        const type = record.type.toLowerCase();
        for(let el of TYPES) {
            if(type.includes(el)) {
                result = el;
            }
        }
    } else {
        const symbol = (record as any).jackpotSymbol;
        switch(symbol) {
            case "J1": 
                result = "grand";
                break;
            case "J2": 
                result = "major";
                break;
            case "J3": 
                result = "maxi";
                break;
            case "J4": 
                result = "mini";
                break;
        }
    }
    return result;
}

const TYPES = ["grand", "major", "maxi", "mini"];


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/util/jackpot.ts